/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Agentiq.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateOutboundBroadcastRequest,
  OutboundBroadcastDetailResponse,
  OutboundBroadcastResponse
} from '../control-api.schemas';

import { orvalControlFetch } from '../../orval-fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetApiOutboundBroadcastsUrl = () => {




  return `/api/outbound-broadcasts`
}

export const getApiOutboundBroadcasts = async ( options?: RequestInit): Promise<OutboundBroadcastResponse[]> => {

  return orvalControlFetch<OutboundBroadcastResponse[]>(getGetApiOutboundBroadcastsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiOutboundBroadcastsQueryKey = () => {
    return [
    `/api/outbound-broadcasts`
    ] as const;
    }


export const getGetApiOutboundBroadcastsQueryOptions = <TData = Awaited<ReturnType<typeof getApiOutboundBroadcasts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOutboundBroadcasts>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiOutboundBroadcastsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOutboundBroadcasts>>> = ({ signal }) => getApiOutboundBroadcasts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiOutboundBroadcasts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiOutboundBroadcastsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOutboundBroadcasts>>>
export type GetApiOutboundBroadcastsQueryError = unknown


export function useGetApiOutboundBroadcasts<TData = Awaited<ReturnType<typeof getApiOutboundBroadcasts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOutboundBroadcasts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOutboundBroadcasts>>,
          TError,
          Awaited<ReturnType<typeof getApiOutboundBroadcasts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiOutboundBroadcasts<TData = Awaited<ReturnType<typeof getApiOutboundBroadcasts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOutboundBroadcasts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOutboundBroadcasts>>,
          TError,
          Awaited<ReturnType<typeof getApiOutboundBroadcasts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiOutboundBroadcasts<TData = Awaited<ReturnType<typeof getApiOutboundBroadcasts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOutboundBroadcasts>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiOutboundBroadcasts<TData = Awaited<ReturnType<typeof getApiOutboundBroadcasts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOutboundBroadcasts>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiOutboundBroadcastsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPostApiOutboundBroadcastsUrl = () => {




  return `/api/outbound-broadcasts`
}

export const postApiOutboundBroadcasts = async (createOutboundBroadcastRequest: CreateOutboundBroadcastRequest, options?: RequestInit): Promise<OutboundBroadcastDetailResponse> => {

  return orvalControlFetch<OutboundBroadcastDetailResponse>(getPostApiOutboundBroadcastsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createOutboundBroadcastRequest,)
  }
);}




export const getPostApiOutboundBroadcastsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiOutboundBroadcasts>>, TError,{data: CreateOutboundBroadcastRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiOutboundBroadcasts>>, TError,{data: CreateOutboundBroadcastRequest}, TContext> => {

const mutationKey = ['postApiOutboundBroadcasts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiOutboundBroadcasts>>, {data: CreateOutboundBroadcastRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiOutboundBroadcasts(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiOutboundBroadcastsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiOutboundBroadcasts>>>
    export type PostApiOutboundBroadcastsMutationBody = CreateOutboundBroadcastRequest
    export type PostApiOutboundBroadcastsMutationError = unknown

    export const usePostApiOutboundBroadcasts = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiOutboundBroadcasts>>, TError,{data: CreateOutboundBroadcastRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiOutboundBroadcasts>>,
        TError,
        {data: CreateOutboundBroadcastRequest},
        TContext
      > => {
      return useMutation(getPostApiOutboundBroadcastsMutationOptions(options), queryClient);
    }
    export const getGetApiOutboundBroadcastsBroadcastIdUrl = (broadcastId: string,) => {




  return `/api/outbound-broadcasts/${broadcastId}`
}

export const getApiOutboundBroadcastsBroadcastId = async (broadcastId: string, options?: RequestInit): Promise<OutboundBroadcastDetailResponse> => {

  return orvalControlFetch<OutboundBroadcastDetailResponse>(getGetApiOutboundBroadcastsBroadcastIdUrl(broadcastId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiOutboundBroadcastsBroadcastIdQueryKey = (broadcastId: string,) => {
    return [
    `/api/outbound-broadcasts/${broadcastId}`
    ] as const;
    }


export const getGetApiOutboundBroadcastsBroadcastIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiOutboundBroadcastsBroadcastId>>, TError = unknown>(broadcastId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOutboundBroadcastsBroadcastId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiOutboundBroadcastsBroadcastIdQueryKey(broadcastId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOutboundBroadcastsBroadcastId>>> = ({ signal }) => getApiOutboundBroadcastsBroadcastId(broadcastId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(broadcastId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiOutboundBroadcastsBroadcastId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiOutboundBroadcastsBroadcastIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOutboundBroadcastsBroadcastId>>>
export type GetApiOutboundBroadcastsBroadcastIdQueryError = unknown


export function useGetApiOutboundBroadcastsBroadcastId<TData = Awaited<ReturnType<typeof getApiOutboundBroadcastsBroadcastId>>, TError = unknown>(
 broadcastId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOutboundBroadcastsBroadcastId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOutboundBroadcastsBroadcastId>>,
          TError,
          Awaited<ReturnType<typeof getApiOutboundBroadcastsBroadcastId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiOutboundBroadcastsBroadcastId<TData = Awaited<ReturnType<typeof getApiOutboundBroadcastsBroadcastId>>, TError = unknown>(
 broadcastId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOutboundBroadcastsBroadcastId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOutboundBroadcastsBroadcastId>>,
          TError,
          Awaited<ReturnType<typeof getApiOutboundBroadcastsBroadcastId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiOutboundBroadcastsBroadcastId<TData = Awaited<ReturnType<typeof getApiOutboundBroadcastsBroadcastId>>, TError = unknown>(
 broadcastId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOutboundBroadcastsBroadcastId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiOutboundBroadcastsBroadcastId<TData = Awaited<ReturnType<typeof getApiOutboundBroadcastsBroadcastId>>, TError = unknown>(
 broadcastId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOutboundBroadcastsBroadcastId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiOutboundBroadcastsBroadcastIdQueryOptions(broadcastId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






